// extracted by mini-css-extract-plugin
export default {"employees_table":"EmployeesTable_employees_table__2qs5R","employee_img":"EmployeesTable_employee_img__J6y2m","edit_btn":"EmployeesTable_edit_btn__Xc44f"};